import PropTypes from 'prop-types';

const ProgressBar = ({ progress = 0, label = '' }) => {
	return (
		<div className='w-full max-w-md mb-6'>
			<div className='w-full bg-gray-200 rounded-full h-2.5'>
				<div
					className='bg-primary h-2.5 rounded-full transition-all duration-300 ease-out'
					style={{ width: `${progress}%` }}
				></div>
			</div>
			<div className='flex justify-between text-xs text-gray-500 mt-2'>
				<span>{label}</span>
				<span>{Math.round(progress)}%</span>
			</div>
		</div>
	);
};

ProgressBar.propTypes = {
	progress: PropTypes.number,
	label: PropTypes.string,
};

export default ProgressBar;
